export default "__VITE_ASSET__eYGnO17z__"